"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateGUID = void 0;
const regEx = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const validateGUID = (guidToValidate) => typeof guidToValidate === 'string' && regEx.test(guidToValidate);
exports.validateGUID = validateGUID;
//# sourceMappingURL=validateGUID.js.map